import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import { Select2Data } from "../../../utils/common";

export const AllUsers = createAsyncThunk(
  "admin/manage-wallet/get-all-users",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.ManageWallet.getAllUsers}?name=${filter?.name ||
          ""}&role_id=${filter?.role_id || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`
      );

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addMoney = createAsyncThunk(
  "admin/manage-wallet/add-amount",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.ManageWallet.addAmount}/${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const reduceMoney = createAsyncThunk(
  "admin/manage-wallet/reduce-amount",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.ManageWallet.reduceAmount}/${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "manage-wallet",
  initialState: {
    all_users: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete

      .addCase(AllUsers.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllUsers.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        state.all_users = action.payload || {};
      })
      .addCase(AllUsers.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;

        state.error = action.payload;
      })

      .addCase(addMoney.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(addMoney.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload;
        // state.data.unshift(action.payload.data);
      })
      .addCase(addMoney.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(reduceMoney.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(reduceMoney.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload;
        // state.data.unshift(action.payload.data);
      })
      .addCase(reduceMoney.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
